<template>
  <a-config-provider :locale="zhCN">
  <div id="app" ref="app">
    <router-view />
  </div>
  </a-config-provider>
</template>

<script>
import Vue from "vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { ConfigProvider } from 'ant-design-vue'
import ElementResizeDetectorMaker from "element-resize-detector";
const erd = ElementResizeDetectorMaker();
Vue.use(ConfigProvider)
export default {
  name: 'App',
  data(){
    return {
      zhCN,
    }
  },
  mounted(){
    const that = this;
    window.addEventListener('message', (e) => {
      if(e?.data?.tag === '__atmAdmin__'){
        //监听页面高度
        erd.listenTo(this.$refs.app, (ele) => {
          let height = ele.offsetHeight < 700 ? 700 : ele.offsetHeight;
          window.parent.postMessage({
            tag:'__atmAdminVue__',
            fnName:'setOffsetHeight',
            value: height
          },e.data?.webOrigin);
        });
        //赋值跨域通信源
        if(e.data?.webOrigin){
          that.$store.commit('atmStore/setAtmWebOrigin',e?.data?.webOrigin)
        }
        //赋值token
        if(e.data?.token !== undefined){
          that.$store.commit('atmStore/setAccessToken',e?.data?.token)
        }
        //赋值用户信息
        if(e.data?.token !== undefined){
          that.$store.commit('atmStore/setCurrentUser',e?.data?.currentUser)
        }
        if(e.data?.route){
          //动态配置路由
          let routerObj = {
            path: e.data?.route.path,
            name: e.data?.route.name,
            component: () => import(`@/view${e.data?.route.componentPath}`),
            props: e.data?.params,
          }
          this.$router.addRoute(routerObj)
          if(e.data?.query){
            this.$router.replace({
              path:routerObj.path,
              query:e.data?.query
            })
          }else{
            this.$router.replace(routerObj.path) 
          }
        }
      }
    });
  }
}
</script>

<style>

</style>
